import { FC } from 'react';
import { Box, Typography, SxProps } from '@mui/material';
import Image from "next/legacy/image";
import { useStyles } from '../../../utils/hooks/useStyles';
import ImageWrapper from '../../images/Image-wrapper';
import { getAppSectionStyles } from './get-app-section.styles';
import AppStoreButtons from '../app-store-buttons/app-store-buttons.component';
import getAppPhonesImage from '../../../public/assets/images/get-app-phones.webp';

export interface GetAppSectionProps {
	type?: 'better-on-app' | 'find-workout';
	sx?: {
		root?: SxProps;
	};
}

const GetAppSection: FC<GetAppSectionProps> = ({ type = 'better-on-app', sx }) => {
	const styles = useStyles(getAppSectionStyles, type);

	return (
		<Box
			sx={{
				...styles.root,
				...(sx?.root as object),
			}}
		>
			<Box sx={styles.content}>
				<Typography sx={styles.title}>
					{type === 'better-on-app'
						? 'It’s better on the app'
						: 'Find your next workout buddies, teammates and coaches'}
				</Typography>
				<AppStoreButtons />
			</Box>
			<Box sx={styles.phonesImageBox}>
				<ImageWrapper sx={styles.phonesImageWrapper}>
					<Image src={getAppPhonesImage} alt="phones" />
				</ImageWrapper>
			</Box>
		</Box>
	);
};

export default GetAppSection;
